'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _textInput = require('../text-input');

var _textInput2 = _interopRequireDefault(_textInput);

var _constants = require('./constants');

var _util = require('../../util');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PhoneNumberInput = function (_Component) {
  _inherits(PhoneNumberInput, _Component);

  function PhoneNumberInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PhoneNumberInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneNumberInput.__proto__ || Object.getPrototypeOf(PhoneNumberInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: '',
      isPhoneNumberFormat: false
    }, _this.onTextChange = function (text) {
      var isPhoneNumberFormat = _this.state.isPhoneNumberFormat;
      var stripped = (0, _util.stripPhoneFormatting)(text);

      if (isPhoneNumberFormat || !(0, _util.isNumber)(stripped) || stripped.length <= 3) {
        return text.replace(/[^- ()0-9]/g, '');
      }

      if (stripped[0] === '+') {
        stripped = stripped.slice(1);
      }

      if (stripped[0] === '1') {
        stripped = stripped.slice(1);
      }

      var output = void 0;

      if (stripped.length > PhoneNumberInput.maxLength) {
        output = '' + (0, _util.formatNumber)(stripped.slice(0, PhoneNumberInput.maxLength)) + stripped.slice(PhoneNumberInput.maxLength);
      } else {
        output = (0, _util.formatNumber)(stripped);
      }

      return output;
    }, _this.onBlur = function (text) {
      var stripped = (0, _util.stripPhoneFormatting)(text);

      if (!isNaN(parseInt(stripped, PhoneNumberInput.maxLength))) {
        if (stripped.length > PhoneNumberInput.maxLength) {
          return '' + (0, _util.formatNumber)(stripped.slice(0, PhoneNumberInput.maxLength)) + stripped.slice(PhoneNumberInput.maxLength);
        }

        return (0, _util.formatNumber)(stripped);
      }

      return text;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PhoneNumberInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var input = this.props.input;
      this.setState({
        isPhoneNumberFormat: input && (0, _util.getIsTextPhoneNumberFormat)(input.value)
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _state = this.state,
          isPhoneNumberFormat = _state.isPhoneNumberFormat,
          value = _state.value;
      var isTextPhoneNumberFormat = (0, _util.getIsTextPhoneNumberFormat)(value);

      if (!isPhoneNumberFormat && isTextPhoneNumberFormat) {
        this.setState({
          isPhoneNumberFormat: true
        });
      }

      if (!!isPhoneNumberFormat && value === '' && !this.props.disabled) {
        this.setState({
          isPhoneNumberFormat: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state2 = this.state,
          isPhoneNumberFormat = _state2.isPhoneNumberFormat,
          _state2$value = _state2.value,
          value = _state2$value === undefined ? '' : _state2$value;

      var _props = this.props,
          className = _props.className,
          testid = _props['data-testid'],
          input = _props.input,
          onValueChange = _props.onValueChange,
          onChangeFunc = _props.onChange,
          onBlurFunc = _props.onBlur,
          placeholder = _props.placeholder,
          submitFunc = _props.submitFunc,
          rest = _objectWithoutProperties(_props, ['className', 'data-testid', 'input', 'onValueChange', 'onChange', 'onBlur', 'placeholder', 'submitFunc']);

      var editContactPlaceholder = isPhoneNumberFormat && input && input.value;
      var phoneNumberPlaceholder = editContactPlaceholder || placeholder || _constants.PLACEHOLDER;
      return _react2.default.createElement(_textInput2.default, _extends({}, this.props.input, {
        className: (0, _classnames2.default)(_defineProperty({
          'zk-text-input': true
        }, className, !!className)),
        maxLength: value[0] === '1' ? 16 : 14,
        placeholder: phoneNumberPlaceholder,
        onChange: function onChange(e) {
          var text = e.target.value;

          var result = _this2.onTextChange(text);

          if (onChangeFunc) {
            onChangeFunc(result);
          }

          if (onValueChange) {
            onValueChange(result);
          }

          _this2.setState({
            value: result
          });
        },
        onBlur: function onBlur(e) {
          var result = _this2.onBlur(e.target.value);

          if (onBlurFunc) {
            onBlurFunc(result);
          }

          if (onValueChange) {
            onValueChange(result);
          }

          _this2.setState({
            value: result
          });
        },
        value: value,
        onSubmitEditing: submitFunc,
        testid: testid
      }, rest));
    }
  }]);

  return PhoneNumberInput;
}(_react.Component);

PhoneNumberInput.propTypes = {
  onValueChange: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onBlur: _propTypes2.default.func
};
PhoneNumberInput.displayName = 'PhoneNumberInput';
PhoneNumberInput.maxLength = 11;
exports.default = PhoneNumberInput;